import { Button } from '@/components/base/button'
import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { Divider } from '@/components/base/divider'
import { useEffect, useState } from 'react'
import { ClientTypeQuery } from './__generated__/show_query'
import { Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { Badge } from './badge'
import { Accordion } from '@/components/accordion'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { EditDialog } from './edit_dialog'
import { Table as ClientTable } from '@/components/client/table'

type ClientType = ClientTypeQuery['clientTypes']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [clientType, setClientType] = useState<ClientType | null>(null)

  const { data, loading, error } = useQuery<ClientTypeQuery>(Query, { variables: { filters: { idEq: id } } })

  useEffect(() => {
    if (!data || !id) { return }

    setClientType(data.clientTypes.nodes[0])
  }, [id, data])

  const onEdit = () => {
    setOpenEdit(true)
  }
  const onDelete = () => {
    setOpenDelete(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={() => setOpen(false)}>
        <DialogTitle>
          { loading || !clientType
            ? <Loading />
            : <div className="flex flex-row justify-between">
              <Badge clientType={clientType} />
            </div> }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { clientType && <div className="flex flex-col gap-4">
            <div className="grid grid-cols-4 items-center align-center" />
            <Divider />
            <Accordion title="Clients">
              <ClientTable
                filters={{ clientTypeIdEq: clientType.id }}
                hiddenColumns={['Client type']}
                pageSize={20}
                fixedHeight
              />
            </Accordion>
          </div> }
        </DialogBody>
        <DialogActions>
          { clientType && <Button color="amber" onClick={onEdit}>Edit</Button> }
          { clientType && <Button color="red" onClick={onDelete}>Delete</Button> }
        </DialogActions>
      </Dialog>
      { clientType && <EditDialog id={clientType.id} open={openEdit} setOpen={setOpenEdit} /> }
      {
        clientType &&
          <DeleteDialog
            id={clientType.id}
            mutation={DeleteMutation}
            open={openDelete}
            refetchQueries={[TableQuery]}
            setOpen={setOpenDelete}
            onSuccess={onDeleteSuccess}
          />
      }
    </>
  )
}
